// TODO - should consider if we can change the implementation of these functions so we can decide not to include
// in the build stage code which is not relevant to the build environment (there is already a different build for
// node and for browser so maybe we should address it in the build stage while requiring code)
export function isBrowser(){
	return (typeof document !== 'undefined' && typeof window !== 'undefined');
}
export function isServer(){
	return !isBrowser();
}
